import { PitchDisplayPreset, PitchVisDisplayPreset } from '@statsbomb/parachute-types';
import { atom } from 'jotai';
import { unwrap } from 'jotai/utils';
import { atomWithSuspenseQuery } from 'jotai-tanstack-query';
import { fetchClientAtom } from '@/atoms/queries/client';

const rawPitchVisDisplayPresetsAtom = atomWithSuspenseQuery(get => {
  const { fetch } = get(fetchClientAtom);
  return {
    queryKey: ['pitch-vis-display-presets'],
    queryFn: async () => (await fetch(`/pitch-vis-display-presets`)) as Promise<PitchVisDisplayPreset[]>,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  };
});

// Maps bare metric name (e.g. "shots") to display preset name (e.g. "SHOTS").
const pitchVisDisplayPresetsAtom = atom(async get => {
  const { data } = await get(rawPitchVisDisplayPresetsAtom);
  const pitchVisDisplayPresetsMap = new Map(
    data.map(({ metric_key: metricKey, display_preset: displayPreset }) => [metricKey, displayPreset]),
  );

  return pitchVisDisplayPresetsMap;
});

export const unwrappedPitchVisDisplayPresetsAtom = unwrap(
  pitchVisDisplayPresetsAtom,
  prev => prev || new Map<string, PitchDisplayPreset>(),
);
